export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  if (imagePath.startsWith("http")) {
    return imagePath;
  }
  
  const backendUrl = process.env.REACT_APP_MEDIA_BASE || "http://localhost:3001";
  
  // Gabungkan URL dan bersihkan double slash
  const fullUrl = `${backendUrl}/${imagePath}`;
  return fullUrl.replace(/([^:]\/)\/+/g, "$1"); // hapus double slash kecuali setelah protocol
};